import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseFilterRequestDto } from '../types/dtos/base.dto';
import {
  CreateReportDto,
  CreateReportResponseDto,
  GetCreatedReportsResponseDto,
  GetSigiFilesListResponseDto,
} from '../types/dtos/reports.dto';
import { ReportExportFormat, ReportType } from '../types/enums/report.enum';
import { TableTagSeverity } from '../types/interfaces/table.interface';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class ReportService extends BaseService {
  private readonly EXPORT_FORMAT_COLOR_MAP: Record<ReportExportFormat, TableTagSeverity> = {
    [ReportExportFormat.PDF]: TableTagSeverity.DANGER,
    [ReportExportFormat.CSV]: TableTagSeverity.SUCCESS,
  }
  private readonly EXPORT_FORMAT_LABEL_MAP: Record<ReportExportFormat, string> = {
    [ReportExportFormat.PDF]: 'PDF',
    [ReportExportFormat.CSV]: 'CSV',
  }
  private readonly REPORT_TYPE_LABEL_MAP: Record<ReportType, string> = {
    [ReportType.DEVICE]: 'Geräte',
    [ReportType.DEVICE_DETAIL]: 'Geräte Detail',
    [ReportType.ALARM]: 'Alarm',
    [ReportType.MEASUREMENT]: 'Messwerte',
    [ReportType.LOG]: 'Log',
    [ReportType.SIGI]: 'SIGI',
  }

  constructor(
    private readonly _httpClient: HttpClient,
  ) {
    super();
  }

  public createReport(
    report: CreateReportDto,
    exportFormat: ReportExportFormat,
  ): Observable<CreateReportResponseDto> {
    const headers: HttpHeaders = new HttpHeaders({
      Accept: exportFormat,
    });

    return this._httpClient.post<CreateReportResponseDto>(
      `${ this._baseUrl }/report`,
      report,
      {
        headers,
      },
    )
      .pipe(take(1));
  }

  public getCreatedReports(query: BaseFilterRequestDto): Observable<GetCreatedReportsResponseDto> {
    return this._httpClient.get<GetCreatedReportsResponseDto>(
      `${ this._baseUrl }/reports/`, {
        params: this.createQueryParams(query),
      },
    )
      .pipe(take(1));
  }

  public getSigiFiles(): Observable<GetSigiFilesListResponseDto> {
    return this._httpClient.get<GetSigiFilesListResponseDto>(
      `${ this._baseUrl }/report/sigi-files`,
    )
      .pipe(take(1));
  }

  public getReportDownloadUrl(fileName: string): string {
    return `${ environment.publicUrl }report/${ fileName }`;
  }

  public mapExportFormatColor(format: ReportExportFormat): TableTagSeverity {
    return this.EXPORT_FORMAT_COLOR_MAP[format];
  }

  public mapExportFormatLabel(format: ReportExportFormat): string {
    return this.EXPORT_FORMAT_LABEL_MAP[format];
  }

  public mapReportTypeLabel(reportType: ReportType): string {
    return this.REPORT_TYPE_LABEL_MAP[reportType];
  }
}